module.exports = __webpack_public_path__ + "img/dynamic-4.7933f3ab.png";